import { isMockMode, postId, simulateDelay } from "../api";

export const getUserAvatars = (userIds: string[]) => {
	if (isMockMode()) {
		const testData = {
			avatars: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					avatar_Base64: null,
				},
			],
		};

		return simulateDelay(50, () => testData);
	}

	return postId("/users/getavatars", { userIds });
};
